class AuthManager {
  constructor() {
    this.store = null
  }
  
  init(store) {
    this.store = store
  }
  
  checkLogin() {
    if (!this.store) return false
    return this.store.getters['user/isAuthenticated']
  }
  
  getUserInfo() {
    if (!this.store) return null
    return this.store.state.user.userInfo
  }
  
  getToken() {
    if (!this.store) return ''
    return this.store.state.user.token
  }
  
  requireAuth(to, from, next) {
    if (this.checkLogin()) {
      next()
    } else {
      alert('请先登录')
      next('/login')
    }
  }
  
  clearAuth() {
    if (this.store) {
      this.store.dispatch('user/logout')
    }
  }
}

export default new AuthManager()
